export default "__VITE_ASSET__0cfabde9__"